import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(() => ({
  root: {
    flex: 1,
    display: "flex",
    gap: 12,
    flexWrap: "nowrap",
    justifyContent: "space-between"
  },
  textField: {
    width: "100%"
  },
  button: {
    height: 36,
    width: 68,
    borderRadius: 18
  }
}));
